import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, Observable, catchError, of, tap } from 'rxjs';
import { AuthService } from './database/auth.service';
import { LocalService } from './database/local.service';
import { EventBusService } from './event-bus.service';
import { EventData } from '../shared/classes/EventData';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AppInitializationService {
  constructor(
    private authService: AuthService,
    private localService: LocalService,
    private router: Router,
    private eventBusService: EventBusService,
    private messageService: MessageService
  ) {}

  initializeApp(): Promise<boolean> {
    return new Promise((resolve) => {
      console.log("Sesion Iniciada");
      if (this.localService.isLoggedIn) {
        if (this.localService.isRefreshCookieExpired) {
          this.localService.clear();
          this.router.navigate(['/public/login']);
          resolve(false);
          return;
        }

        // Validate refresh token with server
        this.authService.refreshToken().pipe(
          tap(() => {
            resolve(true);
          }),
          catchError((error) => {
            this.localService.clear();
            this.eventBusService.emit(new EventData('logout', null));
            this.router.navigate(['/public/login']);
            resolve(false);
            return EMPTY;
          })
        ).subscribe();
      } else {
        // User is not logged in, no need to validate token
        resolve(true);
      }
    });
  }
}
